import { type CustomerStatus, CustomerStatuses, EMPTY, routes } from '@pmai/contracts';
import { StatusBadge } from '@pmai/ui';
import { useApiQuery } from '../../shared/api/hooks';
import { useEnumLabel } from '../../shared/i18n';

/** The customer's projects A→Z — one query for the projects section and the tasks filters. */
export const useCustomerProjects = (customerId: string) =>
  useApiQuery(routes.projects.list, { query: { customerId, sort: 'name', order: 'asc' } });

export function CustomerStatusBadge({ status }: { status: CustomerStatus | null }) {
  const label = useEnumLabel();
  if (!status) return <span className="text-ink-muted">{EMPTY}</span>;
  const option = CustomerStatuses.byCode(status);
  return <StatusBadge tone={option.tone} label={label(option)} />;
}
